import { isIncreasedFlexibilityEnabled } from '@helpcenter/feature-flags';
import { di } from 'react-magnetic-di';
export interface UseApplySectionBackgroundProps {
    sectionTypename: string;
}

export const useApplySectionBackground = function ({ sectionTypename }: UseApplySectionBackgroundProps) {
    di(isIncreasedFlexibilityEnabled);
    const allowedSectionBackgroundTypes = ['HelpLayoutHeroElement', 'HelpLayoutAnnouncementElement'];

    if (isIncreasedFlexibilityEnabled()) {
        // allowed for all
        return true;
    }
    return allowedSectionBackgroundTypes.includes(sectionTypename);
};
